import styled from 'styled-components'


export const WisherContainer = styled.div`
background-color: none;
width: 70%;
height: 70px;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
border: none;
border-radius: 5px;
box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
padding-top: 5px;
padding-bottom: 5px;
`;
export const WellWisher = styled.div`
font-family: Roboto;
font-size: 16px;
font-weight: 500;
text-transform: capitalize;
color: tomato;
margin-bottom: 3px;
`;